// extracted by mini-css-extract-plugin
export default {"body-container":"body-container___DJV3I"};